<template>
  <div class="ai-change-prompt-effect">
    <md-button
      class="md-primary md-raised"
      @click="openPrompt"
    >
      Open Editor
    </md-button>

    <md-dialog
      :md-active="state.openPromptDialog"
      :md-close-on-esc="true"
      class="prompt-dialog"
      @md-clicked-outside="closePrompt"
    >
      <md-dialog-title>Add to Prompt</md-dialog-title>
      <md-dialog-content class="dialog-content">
        <html-editor
          :contents="promptMarkup"
          :readonly="readonly"
          :reload="state.reload"
          :max-chars="500"
          :prevent-emojis="true"
          @update="updatePrompt"
          @disabled="updatePromptDisabled"
        />
        <label class="reason-label">Reason</label>
        <div class="reason-container">
          <el-input
            class="reason-input"
            placeholder="Reason for Addition"
            :value="state.effect.reason"
            @change="updateReason"
          />
          <help-tooltip v-if="errors.length" type="error">
            <span v-for="error in errors" :key="error.message">{{
              error.message
            }}</span>
          </help-tooltip>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="" @click="closePrompt">Cancel</md-button>
        <md-button class="md-raised" :disabled="state.saveDisabled" @click="savePrompt">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import HelpTooltip from '~lib/common/components/HelpTooltip.vue';
import HtmlEditor from '~lib/common/components/HtmlEditor/HtmlEditor.vue';
import nodeMixins from './mixins/NodeMixins';

export default {
  name: 'ai-change-prompt-effect',
  components: {
    HtmlEditor,
    HelpTooltip,
  },
  mixins: [ nodeMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {
          prompt: {
            markup: null
          }
        },
        dirtyPrompt: null,
        saveDisabled: true,
        reload: false,
        openPromptDialog: false,
      },
    };
  },
  computed: {
    promptMarkup() {
      return this.state.effect.prompt && this.state.effect.prompt.markup ? this.state.effect.prompt.markup.en : null;
    },
  },
  mounted() {
    window.addEventListener('popstate', this.handleBackButton);
    this.syncState();
    this.update();
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handleBackButton);
  },
  methods: {
    syncState() {
      this.state.effect = this.getData(this.ikey) || { prompt: { markup: null } };
      this.state.dirtyPrompt = this.state.effect.prompt;
      this.state.dirtyReason = this.state.effect.reason;
    },
    openPrompt() {
      this.state.openPromptDialog = true;
    },
    savePrompt() {
      this.state.effect.prompt = this.state.dirtyPrompt;
      // A hacky way to get the HtmlEditor to reload its contents
      this.state.reloadPrompt = true;
      this.$nextTick(() => {
        this.state.reloadPrompt = false;
      });
      this.state.effect.reason = this.state.dirtyReason;
      this.update();
      this.closePrompt();
    },
    closePrompt() {
      this.state.openPromptDialog = false;
    },
    updatePrompt(contents) {
      this.state.dirtyPrompt = {
        markup: {
          en: contents.markup
        },
        contents: {
          en: contents.content
        }
      };
    },
    updatePromptDisabled(value) {
      this.state.saveDisabled = value;
    },
    updateReason(reason) {
      this.state.dirtyReason = reason;
    },
    update() {
      this.putData(this.ikey, { type: 'AI_UPDATE_PROMPT', ...this.state.effect });
      this.emitter.trigger('process', this.control);
    },
    handleBackButton() {
      // The md-dialog was not closing if you clicked the back button on the browser.
      // This is probably because the component is dynamically loaded.  This work around
      // forces a close when the back button is pressed.
      this.closePrompt();
    }
  },
}
</script>

<style scoped>
.prompt-dialog {
  display: flex;
  flex-direction: column;
  min-width: 80%;
  background-color: #F3F3F3;
  z-index: 1003;
}
.dialog-content {
  display: flex;
  flex-direction: column;
}
.html-editor {
  font-size: 16px;
  margin-bottom: 10px;
  flex: 1;
}
.html-editor >>> .editor {
  max-height: 670px;
}
.reason-label {
  margin-top: 10px;
}
.reason-input {
  margin-top: 4px;
  font-size: 16px;
}
.reason-container {
  display: flex;
  flex-direction: row;
}
</style>